import { ReactNode } from 'react'

import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react'

interface CustomModalProps {
  children: ReactNode
  disableOutsideClick?: boolean
  icon?: ReactNode
  modalWidth?: string
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
  showModal: boolean
  title?: ReactNode
}

const CustomModal: React.FC<CustomModalProps> = ({
  children,
  disableOutsideClick = false,
  icon,
  modalWidth = 'max-w-xs',
  setShowModal,
  showModal,
  title,
}) => {
  if (!showModal) {
    return null
  }
  return (
    <Dialog
      as="div"
      className="relative z-10"
      onClose={() => !disableOutsideClick && setShowModal(false)}
      open={showModal}
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-900/50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center text-center">
          <DialogPanel
            className={`${modalWidth} w-full transform overflow-hidden overflow-y-auto rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all`}
          >
            <div>
              <div className="sm:flex sm:items-start">
                {icon && (
                  <div className="mx-auto flex size-12 shrink-0 items-center justify-center sm:mx-0 sm:mr-4">
                    {icon}
                  </div>
                )}
                <div className="mt-3 w-full text-center sm:mt-0 sm:text-left">
                  {title && (
                    <DialogTitle
                      as="h3"
                      className="text-base font-semibold text-gray-900"
                    >
                      {title}
                    </DialogTitle>
                  )}
                  <div className="mt-2">{children}</div>
                </div>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}

export default CustomModal
